<template>
  <el-dialog v-model="state.visible" title="" width="470px" class="dialog-wrapper">
    <div class="up-block">
      <img class="logo" :src="require(`@/assets/images/common/logo-${userStore.themeMode}.png`)" />
      <span class="logo-text">{{ $t('pecenter.affiliateShare') }}</span>
    </div>
    <div class="ipt-block">
      <span class="link"> {{ $props.linkUrl }}</span>
      <span class="copy-text" @click="copyClip">{{
        $t('pecenter.copyText')
        }}</span>
    </div>
    <div class="bottom-block">
      {{ $t('common.noticeMsg') }}
    </div>
  </el-dialog>
</template>

<script setup>
import Clipboard from 'clipboard';
import { ElMessage } from 'element-plus';
import { defineExpose, defineProps, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores'
const { t } = useI18n();
const userStore = useUserStore()
const state = reactive({
  visible: false
});
const $props = defineProps({
  linkUrl: {
    type: String,
    default: ''
  }
});

const openModal = () => {
  state.visible = true;
};
const copyClip = () => {
  Clipboard.copy($props.linkUrl);
  ElMessage({ type: 'success', message: t('product.copySuccess') });
};

defineExpose({
  openModal
});
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  .up-block {
    padding: 0 30px;
    display: flex;
    align-items: center;
    margin-top: -20px;

    .logo {
      width: 95px;
      height: 31px;
    }

    .logo-text {
      margin-left: 16px;
      font-size: 20px;
      font-weight: 900;
      color: var(--border-black-1);
      padding-left: 16px;
      border-left: 1px solid var(--border-black-1);
      height: 24px;
    }
  }

  .ipt-block {
    margin-top: 50px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    .link {
      width: 290px;
      display: block;
      border: 1px dashed var(--primary-color);
      color: var(--black-color-3d);
      font-size: 18px;
      font-weight: bold;
      height: 44px;
      line-height: 44px;
      padding-left: 16px;
      padding-right: 16px;
      border-radius: 8px 0px 0px 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .copy-text {
      display: block;
      height: 44px;
      width: 80px;
      font-size: 18px;
      color: var(--white-color-1);
      font-weight: bold;
      background: var(--primary-color);
      line-height: 44px;
      text-align: center;
      border-radius: 0px 8px 8px 0px;
      cursor: pointer;
    }
  }

  .bottom-block {
    padding-bottom: 24px;
    padding-top: 16px;
    color: var(--black-color-3d);
    width: 326px;
    text-align: center;
    font-size: 10px;
    margin: auto;
  }
}
</style>
